import { React, useState, useEffect, useContext } from "react";
import {
  faCoins,
  faVectorSquare,
  faHome,
  faBed,
  faBath,
  faStar,
  faMoneyCheckAlt,
  faChevronLeft,
} from "@fortawesome/free-solid-svg-icons";
import "../PropertyBrowser.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import CustomSelect from "../../../components/Shared/CustomSelect";
import { useTranslateKey } from "../../../components/translation/useTranslateKey";
import { LangContext } from "../../../components/translation/langugeContext";
function AsideFilter({
  pageData,
  display_max_price,
  max_area,
  currency,
  filterData,
  setFilterData,
  onApply,
  onReset,
}) {
  const { lang } = useContext(LangContext);
  const t = useTranslateKey();
  const location = useLocation();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < 768;
      setSidebarCollapsed(isMobile);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Handle changes in filter fields
  const handleFilterChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFilterData((prev) => {
      const updated = {
        ...prev,
        [name]:
          type === "checkbox"
            ? checked
              ? [...(prev[name] || []), value]
              : (prev[name] || []).filter((v) => v !== value)
            : value,
      };

      // Reset child filters if parent changes
      if (name === "country") {
        updated.city = "";
        updated.area = "";
      } else if (name === "city") {
        updated.area = "";
      }

      return updated;
    });
  };

  const selectOption = (name, value) => {
    setFilterData((prev) => {
      const currentValue = prev[name];
      return {
        ...prev,
        [name]: currentValue === value ? "" : value, // Toggle selection
      };
    });
  };

  const toggleSidebar = () => setSidebarCollapsed((prev) => !prev);

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      opacity: state.isDisabled ? 0.6 : 1,
      backgroundColor: state.isDisabled
        ? "rgba(255, 255, 255, 0.4)"
        : state.isFocused
        ? "rgba(255, 255, 255, 0.15)"
        : "#11132F",
      border: state.isDisabled
        ? "1px solid #555"
        : state.isFocused
        ? "1px solid #f9c835"
        : "1px solid #332d7e",
      //     borderColor: state.isDisabled ? 'transparent' : '#ccc',

      borderRadius: 8,
      color: "#fff",
      height: 53,
      paddingLeft: 16,
      paddingRight: 40,
      boxShadow: "none",
      transition: "all 0.3s ease",
      "&:hover": {
        backgroundColor: state.isFocused
          ? "rgba(255,255,255,0.15)"
          : "rgba(0,0,0,0.3)",
        borderColor: state.isFocused ? "#f9c835" : "rgba(255,255,255,0.2)",
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#aaa",
      position: "absolute",
      right: 12,
      padding: 0,
    }),
    indicatorSeparator: () => ({ display: "none" }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#11132F",
      border: "1px solid #f9c835",
      borderRadius: 8,
      marginTop: 4,
      color: "#fff",
      zIndex: 9999,
    }),
    menuList: (provided) => ({
      ...provided,

      scrollbarColor: "#007ACC transparent", // scroller color
      scrollbarWidth: "thin",
    }),
    option: (base, state) => ({
      ...base,
      cursor: "pointer",
      color: "#fff",
      backgroundColor: state.isFocused ? "#007ACC" : "#11132f",

      textAlign: "left", // text left
      paddingLeft: "12px",
      ":active": { backgroundColor: "#007ACC" },
    }),
    singleValue: (base) => ({ ...base, color: "#fff" }),
    placeholder: (base) => ({ ...base, color: "#fff" }),
    valueContainer: (base) => ({ ...base, paddingLeft: 0 }),
  };

  return (
    <aside id="filtersSidebar">
      {/* Collapse Button */}
      <button
        onClick={toggleSidebar}
        className={`collapsed-filter-btn md:hidden fixed top-1/2 transform -translate-y-1/2  text-white
           p-2 rounded-r-lg shadow-lg z-50 duration-300 flex items-center
            ${
              sidebarCollapsed
                ? ""
                : "collapsed-filter-btn-left" /* Adjust this value to match your expanded sidebar width */
            }
         `}
      >
        <FontAwesomeIcon
          icon={faChevronLeft}
          className={`sidebar-icon transition-transform duration-300 ${
            sidebarCollapsed ? "rotate-180" : ""
          }`}
        />
      </button>

      <div
        className={
          sidebarCollapsed
            ? " p-4 pb-16 -translate-x-full w-0 opacity-0 md:w-20 md:translate-x-0 md:opacity-100 transition-all duration-300 delay-100"
            : "p-4 pb-16"
        }
      >
        <form
          id="filterForm"
          className={`filters-sidebar${
            lang === "ar" ? " sidebar-ar" : " sidebar-en"
          } transition-all duration-300 delay-100`}
          onSubmit={(e) => {
            e.preventDefault();
            onApply();
          }}
        >
          <div className="sticky-filters-header">
            <div className="flex justify-between items-center mb-3">
              <h3 className="text-lg font-semibold text-white">
                {t("filters")}
              </h3>
              <button
                type="button"
                onClick={onReset}
                className="reset-filter-btn text-accent-yellow hover:text-white transition-colors text-sm"
              >
                {t("resetAll")}
              </button>
            </div>

            <button
              type="submit"
              className="submit-filter-btn applyhover w-full text-primary-darker hover:text-white font-bold py-2 px-4 rounded-lg transition-colors"
            >
              {t("applyFilters")}
            </button>
          </div>

          {/* Price Range Filter */}
          <div className="filter-section mt-0.5">
            <h3 className="filter-title flex items-center gap-2">
              <FontAwesomeIcon icon={faCoins} />
              {t("priceRange")}
            </h3>
            <div className="space-y-4">
              <div className="flex justify-between text-white text-sm mb-2">
                <span>{t("minPrice")}:</span>
                <span id="priceMin">
                  {filterData.min_price} {currency.code}
                </span>
              </div>
              <input
                type="range"
                className="range-slider"
                min="0"
                max={display_max_price}
                step={Math.max(1, Math.round(display_max_price * 0.001))}
                id="priceRangeMin"
                name="min_price"
                value={filterData.min_price}
                onChange={(e) => {
                  const newMin = parseInt(e.target.value);
                  setFilterData((prev) => {
                    let newMax = prev.max_price;
                    if (newMin > prev.max_price) {
                      newMax = newMin;
                    }
                    return {
                      ...prev,
                      min_price: newMin,
                      max_price: newMax,
                    };
                  });
                }}
              />
              <div className="flex justify-between text-white text-sm mb-2">
                <span>{t("maxPrice")}:</span>
                <span id="priceMax">
                  {filterData.max_price} {currency.code}
                </span>
              </div>
              <input
                type="range"
                className="range-slider"
                min="0"
                max={display_max_price}
                step={Math.max(1, Math.round(display_max_price * 0.001))}
                id="priceRangeMax"
                name="max_price"
                value={filterData.max_price}
                onChange={(e) => {
                  const newMax = parseInt(e.target.value);
                  setFilterData((prev) => {
                    let newMin = prev.min_price;
                    if (newMax < prev.min_price) {
                      newMin = newMax;
                    }
                    return {
                      ...prev,
                      min_price: newMin,
                      max_price: newMax,
                    };
                  });
                }}
              />
            </div>
          </div>

          {/* Area Range Filter */}
          <div className="filter-section">
            <h3 className="filter-title flex items-center gap-2">
              <FontAwesomeIcon icon={faVectorSquare} />
              {t("areaRange")}
            </h3>
            <div className="space-y-4">
              <div className="flex justify-between text-white text-sm mb-2">
                <span>{t("minArea")}:</span>
                <span id="areaMin">
                  {filterData.area_min} {t("m2")}
                </span>
              </div>
              <input
                type="range"
                className="range-slider"
                min="0"
                max={max_area}
                step="10"
                id="areaRangeMin"
                name="area_min"
                value={filterData.area_min}
                onChange={(e) => {
                  const newMin = parseInt(e.target.value);
                  setFilterData((prev) => {
                    let newMax = prev.area_max;
                    if (newMin > prev.area_max) {
                      newMax = newMin;
                    }
                    return {
                      ...prev,
                      area_min: newMin,
                      area_max: newMax,
                    };
                  });
                }}
              />
              <div className="flex justify-between text-white text-sm mb-2">
                <span>{t("maxArea")}:</span>
                <span id="areaMax">
                  {filterData.area_max} {t("m2")}
                </span>
              </div>
              <input
                type="range"
                className="range-slider"
                min="0"
                max={max_area}
                step="10"
                id="areaRangeMax"
                name="area_max"
                value={filterData.area_max}
                onChange={(e) => {
                  const newMax = parseInt(e.target.value);
                  setFilterData((prev) => {
                    let newMin = prev.area_min;
                    if (newMax < prev.area_min) {
                      newMin = newMax;
                    }
                    return {
                      ...prev,
                      area_min: newMin,
                      area_max: newMax,
                    };
                  });
                }}
              />
            </div>
          </div>

          {/* Property Type Filter */}
          <div className="filter-section">
            <h3 className="filter-title flex items-center gap-2">
              <FontAwesomeIcon icon={faHome} />
              {t("form_propertyType")}
            </h3>
            <div className="space-y-2">
              {pageData?.property_categories?.map((category) => (
                <div key={category.id}>
                  {/* <h4 className="text-lg text-white">{category.category_en}</h4> */}
                  {category.types.map((type) => (
                    <label
                      key={type.id}
                      className="checkbox-wrapper flex items-center justify-between text-white"
                    >
                      <span>{lang === "ar"?type.type_ar:type.type_en.charAt(0).toUpperCase() + type.type_en.slice(1)}</span>
                      <input
                        type="checkbox"
                        className="accent-yellow"
                        name="new_property_type"
                        value={type.id} // Use the id instead of type_en or type_id
                        checked={filterData.new_property_type.includes(
                          type.id.toString()
                        )} // Check if the type id is in the filterData
                        onChange={handleFilterChange}
                      />
                    </label>
                  ))}
                </div>
              ))}
            </div>
          </div>

          {/* Bedrooms Filter */}

          <div className="filter-section">
            <h3 className="filter-title flex items-center gap-2">
              <FontAwesomeIcon icon={faBed} />
              {t("bedroomsLabel")}
            </h3>
            <div className="flex flex-wrap gap-2">
              {["studio", "1", "2", "3", "4+"].map((option) => {
                const isSelected = filterData.bedrooms === option;
                return (
                  <button
                    key={option}
                    type="button"
                    onClick={() => selectOption("bedrooms", option)}
                    className={`button1 ${isSelected ? "button2" : "button3"}`}
                  >
                    {t(option)}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Bathrooms Filter */}
          <div className="filter-section">
            <h3 className="filter-title flex items-center gap-2">
              <FontAwesomeIcon icon={faBath} />
              {t("bathroomsLabel")}
            </h3>
            <div className="flex flex-wrap gap-2">
              {["1", "2", "3", "4+"].map((option) => {
                const isSelected = filterData.bathrooms === option;
                return (
                  <button
                    key={option}
                    type="button"
                    onClick={() => selectOption("bathrooms", option)}
                    className={`button1 ${isSelected ? "button2" : "button3"}`}
                  >
                    {option}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Features Filter */}
          <div className="filter-section">
            <h3 className="filter-title flex items-center gap-2">
              <FontAwesomeIcon icon={faStar} />
              {t("features")}
            </h3>
            <div className="space-y-2">
              {pageData?.amenities?.map((amenity) => (
                <label
                  key={amenity.id}
                  className="checkbox-wrapper flex items-center justify-between text-white"
                >
                  <span>{lang === "ar" ? amenity.name_ar : amenity.name}</span>
                  <input
                    type="checkbox"
                    className="accent-yellow"
                    name="amenities"
                    value={amenity.id}
                    checked={filterData.amenities.includes(
                      amenity.id.toString()
                    )}
                    onChange={handleFilterChange}
                  />
                </label>
              ))}
            </div>
          </div>

          {/* Developer Filter */}
          <div className="filter-section">
            <h3 className="filter-title flex items-center gap-2">
              <i className="fas fa-building"></i>
              {t("developers")}
            </h3>
            <CustomSelect
              options={[
                { value: "", label: t("allDevelopers") },
                ...pageData.developers?.map((d) => ({
                  value: d.id,
                  label: lang === "ar" ? d.name_ar : d.name,
                })),
              ]}
              placeholder={t("allDevelopers")}
              value={filterData.developer}
              onChange={(val) =>
                setFilterData((prev) => ({ ...prev, developer: val }))
              }
            />
          </div>

          {/* Location Field */}
          {/* Country Filter */}
          <div className="filter-section">
            <h3 className="filter-title flex items-center gap-2">
              <i className="fas fa-globe"></i> {t("country")}
            </h3>
            <Select
              className="w-full"
              classNamePrefix="react-select"
              options={[
                { value: "", label: t("selectCountry") },
                ...(pageData.normalized_countries?.map((country) => ({
                  value: country.id.toString(),
                  label: lang === "ar" ? country.name_ar : country.name_en,
                })) || []),
              ]}
              placeholder={t("selectCountry")}
              value={{
                value: filterData.country,
                label: pageData.normalized_countries?.find(
                  (c) => String(c.id) === String(filterData.country)
                )
                  ? lang === "ar"
                    ? pageData.normalized_countries.find(
                        (c) => String(c.id) === String(filterData.country)
                      ).name_ar
                    : pageData.normalized_countries.find(
                        (c) => String(c.id) === String(filterData.country)
                      ).name_en
                  : t("selectCountry"),
              }}
              onChange={(opt) =>
                setFilterData((prev) => ({
                  ...prev,
                  country: opt?.value || "",
                  city: "",
                  area: "",
                }))
              }
              isSearchable={false}
              styles={{
                control: (base, state) => ({
                  ...base,
                  backgroundColor: state.isFocused
                    ? "rgba(255, 255, 255, 0.15)"
                    : "#11132F",
                  border: state.isFocused
                    ? "1px solid #f9c835"
                    : "1px solid #332d7e",
                  borderRadius: 8,
                  transition: "all 0.3s ease",
                  color: "#fff",
                  height: "53px",
                  outline: "none",
                  paddingLeft: "16px",
                  paddingRight: "40px",
                  display: "flex",
                  alignItems: "center",
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: state.isFocused
                      ? "rgba(255, 255, 255, 0.15)"
                      : "rgba(0, 0, 0, 0.3)",
                    borderColor: state.isFocused
                      ? "#f9c835"
                      : "rgba(255, 255, 255, 0.2)",
                  },
                }),
                dropdownIndicator: (base) => ({
                  ...base,
                  color: "#aaa",
                  position: "absolute",
                  right: "12px",
                  padding: 0,
                }),
                indicatorSeparator: () => ({
                  display: "none",
                }),
                menu: (base) => ({
                  ...base,
                  backgroundColor: "#11132F",
                  border: "1px solid #f9c835",
                  borderRadius: 8,
                  marginTop: 4,
                  color: "white",
                  zIndex: 9999,
                }),
                menuList: (provided) => ({
                  ...provided,

                  scrollbarColor: "#007ACC transparent", // scroller color
                  scrollbarWidth: "thin",
                }),

                option: (base, state) => ({
                  ...base,
                  cursor: "pointer",
                  color: "#fff",
                  backgroundColor: state.isFocused ? "#007ACC" : "#11132f",
                  textAlign: "left", // text left
                  paddingLeft: "12px",
                  ":active": {
                    backgroundColor: "#007ACC",
                  },
                }),
                singleValue: (base) => ({
                  ...base,
                  color: "#fff",
                }),
                placeholder: (base) => ({
                  ...base,
                  color: "#fff",
                  marginLeft: 0,
                  paddingLeft: 0,
                }),
                valueContainer: (base) => ({
                  ...base,
                  paddingLeft: "0px",
                  justifyContent: "flex-start",
                }),
              }}
            />
          </div>

          {/* City Filter */}
          <div className="filter-section">
            <h3 className="filter-title flex items-center gap-2">
              <i className="fas fa-city"></i> {t("city")}
            </h3>
            <Select
              className="w-full"
              classNamePrefix="react-select"
              options={[
                { value: "", label: t("selectCity") },
                ...pageData.normalized_cities
                  .filter(
                    (c) => String(c.country_id) === String(filterData.country)
                  )
                  .map((city) => ({
                    value: city.id.toString(),
                    label: lang === "ar" ? city.name_ar : city.name_en,
                  })),
              ]}
              placeholder={t("selectCity")}
              value={{
                value: filterData.city,
                label: pageData.normalized_cities.find(
                  (c) => String(c.id) === String(filterData.city)
                )
                  ? lang === "ar"
                    ? pageData.normalized_cities.find(
                        (c) => String(c.id) === String(filterData.city)
                      ).name_ar
                    : pageData.normalized_cities.find(
                        (c) => String(c.id) === String(filterData.city)
                      ).name_en
                  : t("selectCity"),
              }}
              onChange={(opt) =>
                setFilterData((prev) => ({
                  ...prev,
                  city: opt?.value || "",
                  area: "", // Reset area
                }))
              }
              isDisabled={!filterData.country}
              isSearchable={false}
              styles={selectStyles}
            />
          </div>

          {/* Area Filter */}
          <div className="filter-section">
            <h3 className="filter-title flex items-center gap-2">
              <i className="fas fa-map-marker-alt"></i> {t("area")}
            </h3>

            <Select
              className="w-full"
              classNamePrefix="react-select"
              options={[
                { value: "", label: t("select_area") },
                ...pageData.normalized_areas
                  .filter((a) => String(a.city_id) === String(filterData.city))
                  .map((area) => ({
                    value: area.id.toString(),
                    label: lang === "ar" ? area.name_ar : area.name_en,
                  })),
              ]}
              placeholder={t("select_area")}
              value={{
                value: filterData.area,
                label: pageData.normalized_areas.find(
                  (a) => String(a.id) === String(filterData.area)
                )
                  ? lang === "ar"
                    ? pageData.normalized_areas.find(
                        (a) => String(a.id) === String(filterData.area)
                      ).name_ar
                    : pageData.normalized_areas.find(
                        (a) => String(a.id) === String(filterData.area)
                      ).name_en
                  : t("select_area"),
              }}
              onChange={(opt) =>
                setFilterData((prev) => ({
                  ...prev,
                  area: opt?.value || "",
                }))
              }
              isDisabled={!filterData.city}
              isSearchable={false}
              styles={selectStyles}
            />
          </div>
          {/* Payment Plan Filter */}
          <div className="filter-section">
            <h3 className="filter-title flex items-center gap-2">
              <FontAwesomeIcon icon={faMoneyCheckAlt} />
              {t("paymentPlan")}
            </h3>
            <div className="space-y-2">
              {[
                { label: t("cash"), value: "cash" },
                { label: t("installments"), value: "installment" },
              ].map((option) => (
                <label
                  key={option.value}
                  className="checkbox-wrapper flex items-center justify-between text-white"
                >
                  <span>
                    {lang === "ar"
                      ? option.label
                      : option.label.charAt(0).toUpperCase() +
                        option.label.slice(1)}
                  </span>
                  <input
                    type="checkbox"
                    className="accent-yellow"
                    name="payment_plan"
                    value={option.value}
                    checked={filterData.payment_plan.includes(option.value)}
                    onChange={handleFilterChange}
                  />
                </label>
              ))}
            </div>
          </div>

          {/* Property Status Filter */}
          <div className="filter-section">
            <h3 className="filter-title flex items-center gap-2">
              <FontAwesomeIcon icon={faHome} />
              {t("propertyStatus")}
            </h3>
            <div className="space-y-2">
              {[
                { label: t("resaleLabel"), value: "resale" },
                { label: t("primaryLabel"), value: "primary" },
              ].map((option) => (
                <label
                  key={option.value}
                  className="checkbox-wrapper flex items-center justify-between text-white"
                >
                  <span>
                    {lang === "ar"
                      ? option.label
                      : option.label.charAt(0).toUpperCase() +
                        option.label.slice(1)}
                  </span>
                  <input
                    type="checkbox"
                    className="accent-yellow"
                    name="property_status"
                    value={option.value}
                    checked={filterData.property_status.includes(option.value)}
                    onChange={handleFilterChange}
                  />
                </label>
              ))}
            </div>
          </div>

          {/* Property Intent Filter */}
          <div className="filter-section">
            <h3 className="filter-title flex items-center gap-2">
              <FontAwesomeIcon icon={faHome} />
              {t("propertyIntent")}
            </h3>
            <div className="space-y-2">
              {[
                { label: t("Buy"), value: "buy" },
                { label: t("Rent"), value: "rent" },
              ].map((option) => (
                <label
                  key={option.value}
                  className="checkbox-wrapper flex items-center justify-between text-white"
                >
                  <span>
                    {lang === "ar"
                      ? option.label
                      : option.label.charAt(0).toUpperCase() +
                        option.label.slice(1)}
                  </span>
                  <input
                    type="checkbox"
                    className="accent-yellow"
                    name="property_intent"
                    value={option.value}
                    checked={filterData.property_intent.includes(option.value)}
                    onChange={handleFilterChange}
                  />
                </label>
              ))}
            </div>
          </div>
        </form>
      </div>
    </aside>
  );
}
export default AsideFilter;
